import { render } from "./member_info.vue?vue&type=template&id=15875da8&scoped=true"
import script from "./member_info.vue?vue&type=script&lang=js"
export * from "./member_info.vue?vue&type=script&lang=js"

import "./member_info.vue?vue&type=style&index=0&id=15875da8&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15875da8"]])

export default __exports__